export enum ExpiringScope {
  Attention = 'attention',
  Expired = 'expired',
  Next30Days = 'next_30_days',
  Next90Days = 'next_90_days',
  Custom = 'custom',
  All = 'all',
}

export enum LotExpiryStatus {
  Expired = 'expired',
  ExpiringSoon = 'expiring_soon',
  Upcoming = 'upcoming',
  Valid = 'valid',
}

export interface ExpiringLotsFilter {
  scope: ExpiringScope;
  dateFrom: Date | null;
  dateTo: Date | null;
}

export interface LotsBucket {
  count: number;
  cost?: number;
}

export interface ExpiringLotsSummary {
  expired: LotsBucket;
  expiringSoon: LotsBucket;
  upcoming: LotsBucket;
  expiringSoonDays: number;
  upcomingDays: number;
}

export interface ExpiringLot {
  id: number;
  code: string;
  productCode: string;
  productName: string;
  laboratory: string | null;
  supplier: string | null;
  expiryDate: string;
  daysLeft: number;
  stock: number;
  cost?: number;
  status: LotExpiryStatus;
}

export interface ExpiringLotsPagination {
  page: number;
  size: number;
  search: string;
}

export interface ExpiringLotsPaginated {
  data: ExpiringLot[];
  page: number;
  size: number;
  total: number;
  summary: ExpiringLotsSummary;
}

interface LotsBucketResponse {
  count: number;
  cost?: number;
}

export interface ExpiringLotsPaginatedResponse {
  page: number;
  size: number;
  total: number;
  summary: {
    expired: LotsBucketResponse;
    expiring_soon: LotsBucketResponse;
    upcoming: LotsBucketResponse;
    expiring_soon_days: number;
    upcoming_days: number;
  };
  data: {
    id: number;
    code: string;
    product_code: string;
    product_name: string;
    laboratory: string | null;
    supplier: string | null;
    expiry_date: string;
    days_left: number;
    stock: number;
    cost?: number;
    status: LotExpiryStatus;
  }[];
}
